import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const SosService = {
    listOpen: async () => axios.get(API_KEEPER + "/sos/event/list/open").then(({data}) => data).catch((err) => { throw err }),

    listHistory: async (filter) => axios.post(API_KEEPER + "/sos/event/list/finalized", filter).then(({data}) => data.data.data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + `/sos/event/${id}`).then(({data}) => data).catch((err) => { throw err }),

    ackEvent: async (id) => axios.post(API_KEEPER + `/sos/event/ack/${id}`).catch((err) => { throw err }),

    finalizeEvent: async (id, formData) => axios.post(API_KEEPER + `/sos/event/finalize/${id}`, formData).catch((err) => { throw err }),

    providences: async () => axios.get(API_KEEPER + "/sos/citizen/info/providences").then(({data}) => data).catch((err) => { throw err }),

    home: async () => axios.get(API_KEEPER + "/sos/home").then(({data}) => data).catch((err) => { throw err }),

    countOpenEvents: async () => axios.get(API_KEEPER + "/sos/home/open-events-count").then(({data}) => data).catch((err) => { throw err }),
};

export default SosService;